<template>
  <div class="ProductPrice Cart">
    <div class="ProductPrice-Status">
      <span v-if="hasPromo && displayPromo && originalPrice > specialPrice" class="ProductPrice-infoSold"> -{{ promoPercent }}% </span>
    </div>
    <div v-if="hasPromo" class="ProductPrice-infoPrice">
      <p class="priceBig" :inner-html.prop="specialPrice | formatPrice(2)"></p>
      <div class="ProductPrice-infoOriginal" v-if="originalPrice">
        <ToolTip v-if="displayTooltip" :text="priceInfo"  :classProps="'right'"></ToolTip>
        <p class="priceOriginal" :inner-html.prop="originalPrice | formatPrice(2)"></p>
      </div>
    </div>
    <div v-else class="ProductPrice-infoPrice">
      <p class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
    </div>
  </div>
</template>

<script>
import PriceMixin from "@/mixins/priceMixin";
import ToolTip from "@/components/ToolTip/ToolTip.vue";
import { mapGetters } from "vuex";

import "@/includes/Product/ProductPrice/ProductPrice.scss";

export default {
  name: "ProductPrice",

  components: {
    ToolTip,
  },

  props: {
    displayPromo: {
      type: Boolean,
      required: false,
      default: true,
    },
    displayTooltip: {
      type: Boolean,
      required: false,
      default: true,
    }
  },

  computed: {
    ...mapGetters({ priceInfo: "getProductPriceInfo" }),
  },

  mixins: [PriceMixin],
};
</script>
